export default {"gitHash":"a24c886180fa485d95f9218c7eaa4632cd1f2d2f","gitHashShort":"a24c886","time":1683524409522,"platform":"linux","arch":"x64"};